export default class Avaliacao {

    constructor(avaliado={}, avaliador={}, uorAvaliador={}, competencia={}, notas=[]) {
        this.avaliado = avaliado;
        this.avaliador = avaliador;
        this.competencia = competencia;
        this.uorAvaliador = uorAvaliador;
        this.notas = notas;
    }
}



// WEBPACK FOOTER //
// ./src/domain/avaliacao/index.js